import { TagsLayers } from '../editors/TagsLayers.js';
import type { SettingsSection } from '../settings-types.js';

/** `settings.layers` (ordered, at most 32, Default first) and `settings.tags` (Unity's Tags and Layers). */
const tagsLayers: SettingsSection = {
  key: 'layers',
  label: 'Tags & Layers',
  icon: 'tag',
  order: 35,
  hint: 'Layer list (physics, cameras) and project tags',
  render: TagsLayers,
  issueKeys: ['tags'],
  fields: [],
};

export default tagsLayers;
